<p-autoComplete minLength="2" inputId="multiple-ac-1" virtualScroll="false" [virtualScrollItemSize]="34"
                [ngModelOptions]="{ standalone: true }" [(ngModel)]="vendorSelectedItem" [dropdown]="false" [forceSelection]="true"
                [suggestions]="vendors" (completeMethod)="filterProducts($event)" field="displayName"
                (onSelect)="onVendorSelected($event)" placeholder="Search Vendor...">
    dataKey="id" >
</p-autoComplete>
